import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { GzSingleSelectComplexBaseDataProvider } from '../dataProvider/GzSingleSelectComplexBaseDataProvider';
import { GzSingleSelectComplexDataProviderFactory } from '../factory/GzSingleSelectComplexDataProviderFactory';
import { GetItemsRequest, GetItemsResponse } from '../types';

export class GzSingleSelectComplexRepository extends BaseWebComponentRepository {
  public dataProviderFactory: GzSingleSelectComplexDataProviderFactory;
  public dataProvider: GzSingleSelectComplexBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new GzSingleSelectComplexDataProviderFactory(),
    });
  }

  async getItems(request: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    return await this.dataProvider.getItems(request);
  }

  async getInitialItems(request: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    return await this.dataProvider.getInitialItems(request);
  }

  shouldWorkWithoutTotalCount(): boolean {
    return this.dataProvider.shouldWorkWithoutTotalCount;
  }
}
